import { render, staticRenderFns } from "./CreateMerchantBusinessAddressModal.vue?vue&type=template&id=547f98fa&scoped=true&"
import script from "./CreateMerchantBusinessAddressModal.vue?vue&type=script&lang=js&"
export * from "./CreateMerchantBusinessAddressModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateMerchantBusinessAddressModal.vue?vue&type=style&index=0&id=547f98fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547f98fa",
  null
  
)

export default component.exports